import { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import DramaCard from '@/components/base/DramaCard';
import Breadcrumb from '@/components/base/Breadcrumb';
import { dramas, categories } from '@/mocks/dramas';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();

  const category = categories.find((c) => c.slug === slug);
  const filteredDramas = slug
    ? dramas.filter((d) => d.categorySlug === slug)
    : dramas;

  useEffect(() => {
    document.title = category
      ? `${category.name} - 香蕉影视高清在线观看`
      : '全部分类 - 香蕉影视';
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [slug, category]);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: 'https://banana-tv.com/' },
              { '@type': 'ListItem', position: 2, name: category?.name || '全部分类' },
            ],
          }),
        }}
      />

      <div className="mx-auto max-w-[1400px] px-4 md:px-6 py-6">
        <Breadcrumb
          items={[
            { label: category?.name || '全部分类' },
          ]}
        />

        <div className="mb-6">
          <h1 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
            {category ? category.name : '全部剧集'}
          </h1>
          <p className="text-sm text-foreground-500 mt-1">
            共 {filteredDramas.length} 部剧集
          </p>
        </div>

        <div className="flex flex-wrap gap-2 mb-8">
          <Link
            to="/"
            className={`px-4 py-2 text-sm rounded-full transition-all duration-200 whitespace-nowrap ${
              !slug
                ? 'bg-primary-500 text-white font-medium'
                : 'bg-secondary-100 text-foreground-700 hover:bg-secondary-200'
            }`}
          >
            全部
          </Link>
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className={`px-4 py-2 text-sm rounded-full transition-all duration-200 whitespace-nowrap ${
                slug === cat.slug
                  ? 'bg-primary-500 text-white font-medium'
                  : 'bg-secondary-100 text-foreground-700 hover:bg-secondary-200'
              }`}
            >
              {cat.name}
            </Link>
          ))}
        </div>

        {filteredDramas.length > 0 ? (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-3 md:gap-5">
            {filteredDramas.map((drama) => (
              <DramaCard key={drama.id} drama={drama} />
            ))}
          </div>
        ) : (
          <div className="text-center py-20">
            <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 rounded-full bg-secondary-100 text-secondary-500">
              <i className="ri-emotion-sad-line text-2xl"></i>
            </div>
            <p className="text-foreground-500 text-sm">暂无相关剧集</p>
          </div>
        )}
      </div>
    </>
  );
}